module.exports = new __parcel__URL__("brand.3bc21133.css").toString();